<script>
  import { sliderTitle, sliderDesc, sliderCta } from './../store/stores';
</script>

{#if $sliderTitle}
  <h3 class="h3 mb-3">{$sliderTitle}</h3>
{/if}

<div class="time-lapse">
  <!-- sprite in use -->
  <div class="time-lapse-sprite mb-3 bg-gray" />
  <!-- progress in use -->
  <div class="time-lapse-progress-bar">
    <!-- slider in use -->
    <input type="range" min="1" value="1" class="time-lapse-slider" />
    <div class="time-lapse-progress-download" />
  </div>
</div>
{#if $sliderDesc}
  <div class="rte-content">
    {@html $sliderDesc}
  </div>
{/if}
{#if $sliderCta}
  <p class="d-inline-block mt-2">
    <a
      href={$sliderCta.Url}
      class="bg-green-5 button d-flex f4 flex-items-center text-white {$sliderCta.Class}"
      target={$sliderCta.Target}
      title={$sliderCta.Title}>
      <span>{$sliderCta.Text}</span>
      <svg
        class="ml-2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="12"
        viewBox="0 0 8 12"
        ><path
          d="M1.055 12L0 10.945 4.945 6 0 1.055 1.055 0l6 6-6 6z"
          fill="currentColor" /></svg>
    </a>
  </p>
{/if}

<style lang="scss">
  .rte-content {
    :global(p) {
      font-size: 16px;
      font-family: inherit;
      line-height:inherit;
      color: var(--colour-fg-default);
    }
  }

  .time-lapse-sprite {
    width: 100%;
    height: 200px;
    background-image: url('/assets/NPWS/images/loading.gif');
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    margin-left: auto;
    margin-right: auto;
  }

  .time-lapse-slider {
    -webkit-appearance: none;
    width: 100%;
    height: 2px;
    background: #ccc;
    outline: none;
    opacity: 0.8;
    transition: opacity 0.2s;
    position: absolute;
    top: 50%;
    z-index: 20;
  }

  .time-lapse-slider:hover {
    opacity: 1;
  }

  .time-lapse-slider {
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 65px;
      height: 21px;
      cursor: pointer;
      background: url('time-lapse-slider-handle.png');
      background-size: 65px 21px;
      border-style: none;
      border-radius: 0;
      border: none;
      z-index: 10;
    }
  }

  .time-lapse-slider {
    &::-moz-range-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 65px;
      height: 21px;
      cursor: pointer;
      background: url('time-lapse-slider-handle.png');
      background-size: 65px 21px;
      border-style: none;
      border-radius: 0;
      border: none;
      z-index: 10;
    }
  }

  .time-lapse-slider {
    &::-ms-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 65px;
      height: 21px;
      cursor: pointer;
      background: url('time-lapse-slider-handle.png');
      background-size: 65px 21px;
      border-style: none;
      border-radius: 0;
      border: none;
    }
  }

  .time-lapse-progress-bar {
    position: relative;
    height: 19px;
    margin-bottom: 8px;
  }

  .time-lapse-progress-download {
    width: 1%;
    height: 100%;
    background-color: #ddd;
    position: absolute;
    top: 0;
    z-index: 2;
  }
</style>
